<template>
  <div class="HowDoesItWork p-t-3 p-b-6">
    <h1 class="text-xs-center">{{t('How does it work')}}</h1>
    <div class="container">
      <div class="row p-t-4">
        <div class="col-md-4">
          <i class="fa fa-search icon" aria-hidden="true"></i>
          <div class="text">
            <h5><b>{{t('Search')}}</b></h5>
            <p>{{t('Search by location and date')}}</p>
          </div>
        </div>
        <div class="col-md-4">
          <i class="fa fa-ticket icon" aria-hidden="true"></i>
          <div class="text">
            <h5><b>{{t('Book')}}</b></h5>
            <p>{{t('Make a booking and wait for a confirmation.')}}</p>
          </div>

        </div>
        <div class="col-md-4">
          <i class="fa fa-tree icon" aria-hidden="true"></i>
          <div class="text">
            <h5><b>{{t('Enjoy')}}</b></h5>
            <p>{{t('Get in touch with nature through unique activities')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>






<script>
  export default {
    name: 'HowDoesItWork',
    data() {
      return {
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
  @import "../../assets/scss/variables";

  .HowDoesItWork {
    background-color: #fff;
  }
  .icon {
    display: block;
    float: left;
    width: 25%;
    font-size: 64px;
  }
  .text {
    float: left;
    width: 65%
  }
  .fa-search {
    color: #00BCD4;
  }
  .fa-ticket {
    color: #FF8800;
  }
  .fa-tree {
    color: #00B48D;
  }
</style>



// WEBPACK FOOTER //
// HowDoesItWork.vue?32c52c0a